// draftScripts.js

const draftScripts = [
  // Original 50 Draft Scripts for Local Retailers
  {
    id: 1,
    goalOfTheDraft: "Promote New Product Launch",
    subjectLine: "Discover Our Latest [Product Name]!",
    purposeOfYourEmail: [
      "Introduce the new product",
      "Highlight key features",
      "Offer introductory discount",
      "Encourage immediate purchase"
    ],
    tellUsAboutYou: "At [Your Store Name], we pride ourselves on bringing the latest and greatest to our community. Founded in [Year], we've been serving [Location] with top-quality products."
  },
  {
    id: 2,
    goalOfTheDraft: "Seasonal Sale Announcement",
    subjectLine: "Spring Sale Starts Now – Up to 50% Off!",
    purposeOfYourEmail: [
      "Announce seasonal sale",
      "Detail discount ranges",
      "Showcase popular items on sale",
      "Create urgency with limited-time offer"
    ],
    tellUsAboutYou: "[Your Store Name] has been your go-to for [product type] since [Year]. Our mission is to provide exceptional value and quality to our neighbors in [Location]."
  },
  {
    id: 3,
    goalOfTheDraft: "Customer Appreciation",
    subjectLine: "Thank You for Being a Valued Customer!",
    purposeOfYourEmail: [
      "Express gratitude",
      "Highlight customer loyalty",
      "Offer a special discount or gift",
      "Encourage feedback"
    ],
    tellUsAboutYou: "We are [Your Store Name], a local retailer committed to [mission statement]. Since our opening in [Year], we've cherished every customer interaction and strive to exceed expectations."
  },
  {
    id: 4,
    goalOfTheDraft: "Announce Store Expansion",
    subjectLine: "We’re Growing! New Location in [Area]",
    purposeOfYourEmail: [
      "Inform about new store location",
      "Highlight benefits of the new location",
      "Invite to grand opening event",
      "Provide directions and contact info"
    ],
    tellUsAboutYou: "[Your Store Name] started in [Year] with a single location and has grown thanks to our amazing community. Our expansion to [New Area] allows us to serve you better than ever before."
  },
  {
    id: 5,
    goalOfTheDraft: "Introduce Loyalty Program",
    subjectLine: "Join Our Loyalty Program Today!",
    purposeOfYourEmail: [
      "Explain loyalty program benefits",
      "Outline how to join",
      "Highlight rewards and exclusive offers",
      "Encourage sign-up"
    ],
    tellUsAboutYou: "Since [Year], [Your Store Name] has been dedicated to offering the best [products/services]. Our new loyalty program is designed to reward our loyal customers like you."
  },
  {
    id: 6,
    goalOfTheDraft: "Holiday Greeting",
    subjectLine: "Happy Holidays from [Your Store Name]!",
    purposeOfYourEmail: [
      "Send warm holiday wishes",
      "Reflect on the year",
      "Thank customers for their support",
      "Share holiday hours or special offers"
    ],
    tellUsAboutYou: "This holiday season, [Your Store Name] celebrates the joy of community and gratitude. Founded in [Year], we've been privileged to serve [Location] with dedication and passion."
  },
  {
    id: 7,
    goalOfTheDraft: "Introduce a Service Offering",
    subjectLine: "New [Service Name] Now Available!",
    purposeOfYourEmail: [
      "Announce new service",
      "Detail benefits and features",
      "Provide pricing or introductory offers",
      "Encourage booking or inquiries"
    ],
    tellUsAboutYou: "At [Your Store Name], innovation is key. Since [Year], we've expanded our offerings to include [new service], ensuring we meet all your [product/service] needs in [Location]."
  },
  {
    id: 8,
    goalOfTheDraft: "Share Customer Testimonials",
    subjectLine: "Hear What Our Customers Are Saying!",
    purposeOfYourEmail: [
      "Share positive testimonials",
      "Highlight customer satisfaction",
      "Encourage others to share their experiences",
      "Build trust"
    ],
    tellUsAboutYou: "[Your Store Name] values every customer story. Established in [Year], our commitment to quality and service has earned us the trust and loyalty of our [Location] community."
  },
  {
    id: 9,
    goalOfTheDraft: "Offer Exclusive Discount",
    subjectLine: "Exclusive Offer Just for You!",
    purposeOfYourEmail: [
      "Provide a special discount code",
      "Explain how to redeem",
      "Highlight eligible products",
      "Set expiration date"
    ],
    tellUsAboutYou: "We at [Your Store Name] have been serving [Location] since [Year], always striving to offer the best deals and highest quality products to our cherished customers."
  },
  {
    id: 10,
    goalOfTheDraft: "Promote Online Store",
    subjectLine: "Shop Our New Online Store Today!",
    purposeOfYourEmail: [
      "Announce online store launch",
      "Highlight ease of shopping",
      "Mention shipping options or promotions",
      "Provide link to the store"
    ],
    tellUsAboutYou: "[Your Store Name] has embraced the digital age to better serve you. Since [Year], we've been your trusted local retailer, and our new online store ensures you can shop anytime, anywhere."
  },
  {
    id: 11,
    goalOfTheDraft: "Event Invitation",
    subjectLine: "Join Us for Our Grand Opening Event!",
    purposeOfYourEmail: [
      "Invite to event",
      "Provide event details (date, time, location)",
      "Highlight activities or specials",
      "Encourage RSVPs"
    ],
    tellUsAboutYou: "Founded in [Year], [Your Store Name] is excited to celebrate our grand opening at our new location in [Area]. We look forward to welcoming our community with exclusive offers and fun activities."
  },
  {
    id: 12,
    goalOfTheDraft: "Highlight Best Sellers",
    subjectLine: "Our Best-Selling [Products] You’ll Love!",
    purposeOfYourEmail: [
      "Showcase top-selling products",
      "Explain why they’re popular",
      "Include customer reviews",
      "Encourage purchase"
    ],
    tellUsAboutYou: "At [Your Store Name], our best-sellers reflect our commitment to quality and customer satisfaction. Since [Year], we've been proud to offer the finest [products] to [Location]."
  },
  {
    id: 13,
    goalOfTheDraft: "Introduce Staff or Team",
    subjectLine: "Meet the Team Behind [Your Store Name]!",
    purposeOfYourEmail: [
      "Introduce key team members",
      "Share their roles and expertise",
      "Highlight their dedication",
      "Create a personal connection with customers"
    ],
    tellUsAboutYou: "[Your Store Name] is powered by a passionate team dedicated to serving [Location]. Since [Year], our staff has been the heart of our operations, ensuring every customer leaves happy."
  },
  {
    id: 14,
    goalOfTheDraft: "Share Company Milestones",
    subjectLine: "Celebrating [Number] Years with You!",
    purposeOfYourEmail: [
      "Highlight company milestones",
      "Reflect on achievements",
      "Thank customers for their support",
      "Share future goals"
    ],
    tellUsAboutYou: "Celebrating [Number] years, [Your Store Name] has grown from a small [type of store] to a beloved [retailer type] in [Location]. Our journey is a testament to our community’s support and trust."
  },
  {
    id: 15,
    goalOfTheDraft: "Provide Helpful Tips or Guides",
    subjectLine: "5 Tips to Enhance Your [Product Use]",
    purposeOfYourEmail: [
      "Share useful tips related to products",
      "Position your store as a helpful resource",
      "Encourage product use and engagement",
      "Link to products or services"
    ],
    tellUsAboutYou: "Since [Year], [Your Store Name] has been dedicated to not only providing quality [products/services] but also empowering our customers with the knowledge to make the most of them."
  },
  {
    id: 16,
    goalOfTheDraft: "Announce Limited Edition Items",
    subjectLine: "Limited Edition [Product] Now Available!",
    purposeOfYourEmail: [
      "Announce limited edition products",
      "Highlight unique features",
      "Create urgency due to limited availability",
      "Encourage immediate purchase"
    ],
    tellUsAboutYou: "At [Your Store Name], we believe in offering exclusive and unique products. Established in [Year], our limited editions reflect our commitment to quality and our customers' distinct tastes."
  },
  {
    id: 17,
    goalOfTheDraft: "Share Industry News or Trends",
    subjectLine: "Stay Ahead with the Latest [Industry] Trends",
    purposeOfYourEmail: [
      "Share relevant industry news",
      "Explain its impact on customers",
      "Position your store as knowledgeable",
      "Encourage engagement or visit"
    ],
    tellUsAboutYou: "[Your Store Name] stays informed on the latest [industry] trends to serve our [Location] community better. Since [Year], we've been at the forefront, ensuring our customers benefit from the best."
  },
  {
    id: 18,
    goalOfTheDraft: "Offer a Free Workshop or Webinar",
    subjectLine: "Free [Workshop/Webinar]: Learn [Topic]!",
    purposeOfYourEmail: [
      "Announce free educational event",
      "Detail what will be covered",
      "Provide date and time",
      "Encourage registration"
    ],
    tellUsAboutYou: "[Your Store Name] is more than just a retailer; we're a community hub. Since [Year], we've hosted numerous events to educate and engage our customers, fostering a knowledgeable community."
  },
  {
    id: 19,
    goalOfTheDraft: "Re-engage Inactive Customers",
    subjectLine: "We Miss You at [Your Store Name]!",
    purposeOfYourEmail: [
      "Acknowledge absence",
      "Offer incentive to return",
      "Highlight new products or improvements",
      "Encourage reconnecting"
    ],
    tellUsAboutYou: "[Your Store Name] has been proudly serving [Location] since [Year]. We've evolved with our community, and we'd love to welcome you back to experience the latest in [products/services]."
  },
  {
    id: 20,
    goalOfTheDraft: "Provide Exclusive Content",
    subjectLine: "Unlock Exclusive Content Just for You!",
    purposeOfYourEmail: [
      "Offer access to special content (e.g., guides, eBooks)",
      "Highlight value of the content",
      "Explain how to access",
      "Encourage sharing"
    ],
    tellUsAboutYou: "At [Your Store Name], we believe in adding value beyond our products. Since [Year], we've been dedicated to enriching our customers' lives with resources and services that matter."
  },
  {
    id: 21,
    goalOfTheDraft: "Introduce Eco-Friendly Initiatives",
    subjectLine: "Our Commitment to Sustainability",
    purposeOfYourEmail: [
      "Share eco-friendly practices",
      "Highlight specific initiatives",
      "Encourage customers to participate",
      "Showcase benefits"
    ],
    tellUsAboutYou: "[Your Store Name] is committed to sustainability and protecting our environment. Since [Year], we've implemented eco-friendly practices to ensure a better future for [Location] and beyond."
  },
  {
    id: 22,
    goalOfTheDraft: "Promote Gift Cards",
    subjectLine: "Give the Gift of Choice with Our Gift Cards",
    purposeOfYourEmail: [
      "Announce availability of gift cards",
      "Explain how to purchase and redeem",
      "Highlight benefits for gift recipients",
      "Encourage as holiday or special occasion gifts"
    ],
    tellUsAboutYou: "Since [Year], [Your Store Name] has offered flexible gifting options to our customers. Our gift cards are perfect for any occasion, allowing your loved ones to choose what they truly want."
  },
  {
    id: 23,
    goalOfTheDraft: "Share Behind-the-Scenes Content",
    subjectLine: "A Behind-the-Scenes Look at [Your Store]",
    purposeOfYourEmail: [
      "Provide a glimpse into daily operations",
      "Highlight unique aspects of the store",
      "Share staff stories or processes",
      "Build a personal connection"
    ],
    tellUsAboutYou: "At [Your Store Name], transparency and authenticity are key. Founded in [Year], we invite you to see what goes into making your shopping experience exceptional every day in [Location]."
  },
  {
    id: 24,
    goalOfTheDraft: "Promote a Referral Program",
    subjectLine: "Refer a Friend & Earn Rewards!",
    purposeOfYourEmail: [
      "Introduce referral program",
      "Explain how it works",
      "Highlight rewards for both referrer and referee",
      "Encourage participation"
    ],
    tellUsAboutYou: "[Your Store Name] thrives on community and word-of-mouth. Since [Year], we've relied on our customers to help us grow, and our new referral program rewards you for spreading the love."
  },
  {
    id: 25,
    goalOfTheDraft: "Announce Payment Options",
    subjectLine: "New Payment Options Now Available!",
    purposeOfYourEmail: [
      "Inform about new payment methods",
      "Explain benefits (e.g., convenience, security)",
      "Provide instructions on how to use",
      "Encourage adoption"
    ],
    tellUsAboutYou: "At [Your Store Name], we strive to make your shopping experience seamless. Since [Year], we've been updating our services, and our latest payment options reflect our commitment to your convenience."
  },
  {
    id: 26,
    goalOfTheDraft: "Highlight Community Involvement",
    subjectLine: "Supporting Our Community Together",
    purposeOfYourEmail: [
      "Share recent community initiatives",
      "Highlight partnerships with local organizations",
      "Encourage customer involvement",
      "Showcase impact"
    ],
    tellUsAboutYou: "[Your Store Name] believes in giving back. Since [Year], we've been actively involved in [community activities], strengthening our bond with the [Location] community we proudly serve."
  },
  {
    id: 27,
    goalOfTheDraft: "Introduce a New Store Feature",
    subjectLine: "Experience Our New [Feature] Today!",
    purposeOfYourEmail: [
      "Announce new store feature (e.g., in-store kiosk, new layout)",
      "Explain benefits to customers",
      "Provide instructions or guides",
      "Encourage usage"
    ],
    tellUsAboutYou: "Innovation is at the heart of [Your Store Name]. Since [Year], we've continuously improved our store to better serve you, and our latest [feature] is designed to enhance your shopping experience."
  },
  {
    id: 28,
    goalOfTheDraft: "Share Exclusive Previews",
    subjectLine: "Sneak Peek: Upcoming [Product/Service]",
    purposeOfYourEmail: [
      "Offer a preview of upcoming products/services",
      "Generate excitement",
      "Provide details or visuals",
      "Encourage anticipation"
    ],
    tellUsAboutYou: "[Your Store Name] is always looking ahead to bring you the best. Since [Year], we've been excited to preview what's next for our [products/services], ensuring you’re always ahead of the curve."
  },
  {
    id: 29,
    goalOfTheDraft: "Announce Partnership or Collaboration",
    subjectLine: "Exciting Partnership with [Partner]!",
    purposeOfYourEmail: [
      "Announce new partnership",
      "Explain benefits to customers",
      "Highlight collaborative offerings",
      "Encourage exploration of joint offerings"
    ],
    tellUsAboutYou: "Collaboration drives innovation at [Your Store Name]. Since [Year], partnering with leaders like [Partner] allows us to enhance our offerings and provide even greater value to our [Location] customers."
  },
  {
    id: 30,
    goalOfTheDraft: "Offer Early Access to Sales",
    subjectLine: "Get Early Access to Our Biggest Sale!",
    purposeOfYourEmail: [
      "Provide early access to sales for subscribers",
      "Explain how to access",
      "Highlight key sale items",
      "Create urgency"
    ],
    tellUsAboutYou: "As a token of our appreciation, [Your Store Name] offers our loyal customers early access to our sales. Since [Year], we've prioritized giving back to our [Location] community with exclusive perks."
  },
  {
    id: 31,
    goalOfTheDraft: "Highlight Health and Safety Measures",
    subjectLine: "Your Safety is Our Priority",
    purposeOfYourEmail: [
      "Detail health and safety protocols",
      "Reassure customers",
      "Highlight any changes to store operations",
      "Encourage continued patronage"
    ],
    tellUsAboutYou: "At [Your Store Name], the well-being of our customers and staff is paramount. Since [Year], we've implemented comprehensive safety measures to ensure a secure and pleasant shopping environment."
  },
  {
    id: 32,
    goalOfTheDraft: "Promote a Contest or Giveaway",
    subjectLine: "Enter Our [Contest/Giveaway] Today!",
    purposeOfYourEmail: [
      "Announce contest or giveaway",
      "Explain how to enter",
      "Highlight prizes",
      "Encourage participation"
    ],
    tellUsAboutYou: "[Your Store Name] loves to engage with our community. Since [Year], we've hosted numerous contests and giveaways to show our appreciation and bring excitement to our [Location] customers."
  },
  {
    id: 33,
    goalOfTheDraft: "Share DIY Projects or Ideas",
    subjectLine: "DIY [Project] Ideas for You!",
    purposeOfYourEmail: [
      "Provide DIY project ideas related to your products",
      "Encourage creativity",
      "Highlight necessary materials",
      "Link to products or tutorials"
    ],
    tellUsAboutYou: "Creativity thrives at [Your Store Name]. Since [Year], we've inspired our customers with DIY projects and ideas, using our quality [products] to bring your visions to life."
  },
  {
    id: 34,
    goalOfTheDraft: "Announce Price Match Guarantee",
    subjectLine: "We Now Price Match Competitors!",
    purposeOfYourEmail: [
      "Introduce price match policy",
      "Explain how it works",
      "Highlight commitment to affordability",
      "Encourage customers to take advantage"
    ],
    tellUsAboutYou: "[Your Store Name] is committed to offering the best prices. Since [Year], we've ensured our customers receive top value, and our new price match guarantee reinforces this promise."
  },
  {
    id: 35,
    goalOfTheDraft: "Promote Gift Guides",
    subjectLine: "Your Ultimate [Holiday/Event] Gift Guide",
    purposeOfYourEmail: [
      "Provide curated gift suggestions",
      "Highlight various categories",
      "Link to products",
      "Encourage easy gifting"
    ],
    tellUsAboutYou: "Finding the perfect gift is easy with [Your Store Name]. Since [Year], we've curated gift guides to help our [Location] community choose thoughtful and meaningful presents for any occasion."
  },
  {
    id: 36,
    goalOfTheDraft: "Share Success Stories",
    subjectLine: "Success Stories from Our Customers!",
    purposeOfYourEmail: [
      "Highlight customer success stories",
      "Showcase how your products/services made a difference",
      "Build trust and credibility",
      "Encourage others to share"
    ],
    tellUsAboutYou: "At [Your Store Name], our customers' successes are our proudest achievements. Since [Year], we've been honored to support [Location] residents in achieving their goals with our [products/services]."
  },
  {
    id: 37,
    goalOfTheDraft: "Provide Maintenance Tips",
    subjectLine: "Keep Your [Product] in Top Shape!",
    purposeOfYourEmail: [
      "Share maintenance or care tips",
      "Extend product lifespan",
      "Position your store as a helpful resource",
      "Encourage proper usage"
    ],
    tellUsAboutYou: "[Your Store Name] is dedicated to ensuring our customers get the most out of their purchases. Since [Year], we've provided ongoing support and tips to maintain the quality and longevity of our [products]."
  },
  {
    id: 38,
    goalOfTheDraft: "Announce Extended Hours",
    subjectLine: "We’re Now Open [New Hours]!",
    purposeOfYourEmail: [
      "Inform about new store hours",
      "Highlight benefits to customers",
      "Encourage visits during extended times",
      "Provide any necessary details"
    ],
    tellUsAboutYou: "To better serve our community, [Your Store Name] has extended our operating hours. Since [Year], we've been committed to flexibility and convenience for our valued [Location] customers."
  },
  {
    id: 39,
    goalOfTheDraft: "Promote Sustainability Products",
    subjectLine: "Go Green with Our Eco-Friendly Products!",
    purposeOfYourEmail: [
      "Highlight sustainable product lines",
      "Explain environmental benefits",
      "Encourage eco-conscious purchasing",
      "Provide product details"
    ],
    tellUsAboutYou: "Sustainability is a core value at [Your Store Name]. Since [Year], we've offered eco-friendly products to help our [Location] community make responsible and impactful choices."
  },
  {
    id: 40,
    goalOfTheDraft: "Offer a Birthday Special",
    subjectLine: "Happy Birthday! Enjoy a Special Gift 🎉",
    purposeOfYourEmail: [
      "Celebrate customer's birthday",
      "Offer a special discount or gift",
      "Personalize the message",
      "Encourage store visit or online use"
    ],
    tellUsAboutYou: "[Your Store Name] loves celebrating with our customers. Since [Year], we've made birthdays extra special by offering personalized gifts and discounts to our beloved [Location] community."
  },
  {
    id: 41,
    goalOfTheDraft: "Share Educational Content",
    subjectLine: "Learn About [Topic] with Us!",
    purposeOfYourEmail: [
      "Provide educational content related to your industry",
      "Share insights or knowledge",
      "Position your store as an expert",
      "Encourage engagement"
    ],
    tellUsAboutYou: "At [Your Store Name], education and empowerment are key. Since [Year], we've been sharing valuable knowledge about [industry/topics] to help our [Location] customers make informed decisions."
  },
  {
    id: 42,
    goalOfTheDraft: "Promote Clearance Items",
    subjectLine: "Clearance Sale – Everything Must Go!",
    purposeOfYourEmail: [
      "Announce clearance sale",
      "Highlight deep discounts",
      "Emphasize limited stock",
      "Encourage quick purchases"
    ],
    tellUsAboutYou: "[Your Store Name] is clearing out inventory to make room for new arrivals. Since [Year], we've offered incredible deals to our [Location] community, ensuring you get the best value."
  },
  {
    id: 43,
    goalOfTheDraft: "Introduce a Subscription Service",
    subjectLine: "Subscribe & Save with [Service Name]!",
    purposeOfYourEmail: [
      "Announce subscription offering",
      "Explain benefits and savings",
      "Provide subscription options",
      "Encourage sign-up"
    ],
    tellUsAboutYou: "Innovation drives [Your Store Name]. Since [Year], we've introduced subscription services to offer our [Location] customers convenience and savings, ensuring you never run out of your favorites."
  },
  {
    id: 44,
    goalOfTheDraft: "Highlight Payment Plans",
    subjectLine: "Flexible Payment Plans Now Available!",
    purposeOfYourEmail: [
      "Introduce payment plans or financing",
      "Explain terms and benefits",
      "Highlight eligible products",
      "Encourage inquiries"
    ],
    tellUsAboutYou: "[Your Store Name] understands that flexibility matters. Since [Year], we've offered payment plans to make our quality [products/services] accessible to everyone in [Location]."
  },
  {
    id: 45,
    goalOfTheDraft: "Share Company Values",
    subjectLine: "Our Commitment to Quality and Service",
    purposeOfYourEmail: [
      "Outline company values",
      "Explain how they benefit customers",
      "Share examples of values in action",
      "Reinforce trust and reliability"
    ],
    tellUsAboutYou: "At [Your Store Name], our values are the foundation of everything we do. Since [Year], we've upheld a commitment to quality and exceptional service, ensuring our [Location] community thrives."
  },
  {
    id: 46,
    goalOfTheDraft: "Announce a Flash Sale",
    subjectLine: "24-Hour Flash Sale – Don’t Miss Out!",
    purposeOfYourEmail: [
      "Announce a limited-time flash sale",
      "Highlight key deals",
      "Create urgency",
      "Encourage immediate action"
    ],
    tellUsAboutYou: "[Your Store Name] is excited to offer a 24-hour flash sale as a thank you to our [Location] customers. Since [Year], we've been dedicated to providing amazing deals and exceptional value."
  },
  {
    id: 47,
    goalOfTheDraft: "Promote Gift Wrapping Services",
    subjectLine: "Free Gift Wrapping for a Limited Time!",
    purposeOfYourEmail: [
      "Announce gift wrapping service",
      "Explain how to avail",
      "Highlight the convenience",
      "Encourage use for upcoming holidays or events"
    ],
    tellUsAboutYou: "Making your gifts special is easy with [Your Store Name]. Since [Year], we've offered gift wrapping services to add that perfect finishing touch for any occasion in our [Location] community."
  },
  {
    id: 48,
    goalOfTheDraft: "Share a Holiday Recipe or DIY",
    subjectLine: "Celebrate [Holiday] with This Recipe!",
    purposeOfYourEmail: [
      "Provide a themed recipe or DIY project",
      "Relate it to your products",
      "Encourage sharing or participation",
      "Link to relevant products or blog"
    ],
    tellUsAboutYou: "[Your Store Name] loves celebrating traditions. Since [Year], we've shared recipes and DIY projects that bring our [Location] community together, using our quality [products] to create memorable moments."
  },
  {
    id: 49,
    goalOfTheDraft: "Promote Virtual Consultations",
    subjectLine: "Book a Virtual Consultation Today!",
    purposeOfYourEmail: [
      "Introduce virtual consultation service",
      "Explain benefits and process",
      "Highlight expertise of consultants",
      "Encourage booking"
    ],
    tellUsAboutYou: "Embracing the future, [Your Store Name] offers virtual consultations to better serve our [Location] customers. Since [Year], we've been dedicated to providing expert advice from the comfort of your home."
  },
  {
    id: 50,
    goalOfTheDraft: "Celebrate a Specific Achievement",
    subjectLine: "[Your Store Name] Reaches [Milestone]!",
    purposeOfYourEmail: [
      "Announce a significant achievement or milestone",
      "Reflect on the journey",
      "Thank customers for their role in the success",
      "Share future aspirations"
    ],
    tellUsAboutYou: "Celebrating [Milestone], [Your Store Name] thanks our incredible [Location] community. Since [Year], your support has driven our success, and we're excited for what the future holds together."
  },

  // Additional 120 Draft Scripts for Various Industries (id:51 to id:170)

  // --- 1. Automotive Industry ---
  {
    id: 51,
    goalOfTheDraft: "Promote New Car Models",
    subjectLine: "Introducing the All-New [Car Model]!",
    purposeOfYourEmail: [
      "Announce the launch of a new car model",
      "Highlight innovative features",
      "Offer test drive appointments",
      "Provide exclusive launch discounts"
    ],
    tellUsAboutYou: "At [Your Dealership Name], we've been passionate about automobiles since [Year]. Located in [Location], we strive to provide our customers with the latest models and exceptional service."
  },
  {
    id: 52,
    goalOfTheDraft: "Service Center Promotion",
    subjectLine: "Keep Your Car in Top Shape with Our Services!",
    purposeOfYourEmail: [
      "Promote maintenance and repair services",
      "Highlight certified technicians",
      "Offer special service packages",
      "Encourage scheduling appointments"
    ],
    tellUsAboutYou: "[Your Dealership Name] is your trusted partner for all automotive needs in [Location]. Since [Year], our service center has been dedicated to ensuring your vehicle runs smoothly."
  },
  {
    id: 53,
    goalOfTheDraft: "Automotive Financing Offer",
    subjectLine: "Drive Your Dream Car with Our Flexible Financing!",
    purposeOfYourEmail: [
      "Introduce new financing options",
      "Highlight low-interest rates",
      "Explain easy application process",
      "Encourage inquiries and applications"
    ],
    tellUsAboutYou: "At [Your Dealership Name], we make car ownership accessible. Since [Year], we've helped [Location] residents finance their dream cars with flexible and affordable options."
  },
  {
    id: 54,
    goalOfTheDraft: "Promote Accessories and Add-ons",
    subjectLine: "Customize Your Ride with Our Accessories!",
    purposeOfYourEmail: [
      "Introduce new accessories",
      "Highlight customization options",
      "Offer bundle discounts",
      "Encourage purchases"
    ],
    tellUsAboutYou: "[Your Dealership Name] offers a wide range of accessories to personalize your vehicle. Since [Year], we've been enhancing [Location] drivers' experiences with top-quality add-ons."
  },
  {
    id: 55,
    goalOfTheDraft: "Customer Appreciation Event",
    subjectLine: "Join Us for Our Annual Customer Appreciation Day!",
    purposeOfYourEmail: [
      "Invite to appreciation event",
      "Provide event details (date, time, location)",
      "Highlight activities and giveaways",
      "Encourage RSVPs"
    ],
    tellUsAboutYou: "At [Your Dealership Name], our customers are our priority. Since [Year], we've hosted events to thank the [Location] community for their loyalty and support."
  },

  // --- 2. Education Industry ---
  {
    id: 56,
    goalOfTheDraft: "Enroll for Upcoming Semester",
    subjectLine: "Secure Your Spot for the [Semester] Semester!",
    purposeOfYourEmail: [
      "Announce enrollment dates",
      "Highlight new courses or programs",
      "Provide information on scholarships",
      "Encourage early registration"
    ],
    tellUsAboutYou: "Founded in [Year], [Your Institution Name] has been a cornerstone of education in [Location]. Our mission is to empower students with knowledge and skills for success."
  },
  {
    id: 57,
    goalOfTheDraft: "Promote Online Courses",
    subjectLine: "Learn Anytime, Anywhere with Our Online Courses!",
    purposeOfYourEmail: [
      "Introduce new online courses",
      "Highlight flexibility and accessibility",
      "Offer introductory discounts",
      "Encourage enrollment"
    ],
    tellUsAboutYou: "[Your Institution Name] embraces modern education methods to provide quality learning experiences. Since [Year], we've been dedicated to making education accessible to all."
  },
  {
    id: 58,
    goalOfTheDraft: "Alumni Success Stories",
    subjectLine: "See How Our Alumni Are Making a Difference!",
    purposeOfYourEmail: [
      "Share success stories of alumni",
      "Highlight their achievements",
      "Encourage current students",
      "Foster community engagement"
    ],
    tellUsAboutYou: "[Your Institution Name] takes pride in our alumni. Since [Year], our graduates have gone on to excel in various fields, contributing to [Location] and beyond."
  },
  {
    id: 59,
    goalOfTheDraft: "Campus Event Announcement",
    subjectLine: "Join Us for [Event Name] on [Date]!",
    purposeOfYourEmail: [
      "Announce upcoming campus event",
      "Provide event details",
      "Highlight special guests or activities",
      "Encourage attendance"
    ],
    tellUsAboutYou: "At [Your Institution Name], we foster a vibrant campus life. Since [Year], we've hosted numerous events to enrich the student experience and build a strong [Location] community."
  },
  {
    id: 60,
    goalOfTheDraft: "Scholarship Opportunities",
    subjectLine: "Apply for Our [Scholarship Name] Today!",
    purposeOfYourEmail: [
      "Announce new scholarship programs",
      "Explain eligibility criteria",
      "Provide application instructions",
      "Encourage applications"
    ],
    tellUsAboutYou: "[Your Institution Name] is committed to supporting our students. Since [Year], we've offered scholarships to ensure that financial constraints do not hinder academic excellence."
  },

  // --- 3. Finance Industry ---
  {
    id: 61,
    goalOfTheDraft: "Promote New Financial Products",
    subjectLine: "Introducing Our New [Product Name]!",
    purposeOfYourEmail: [
      "Announce new financial product",
      "Highlight benefits and features",
      "Provide information on how to apply",
      "Encourage consultations"
    ],
    tellUsAboutYou: "Since [Year], [Your Bank/Finance Company] has been committed to providing reliable financial solutions in [Location]. Our expertise helps you achieve your financial goals."
  },
  {
    id: 62,
    goalOfTheDraft: "Financial Literacy Workshop",
    subjectLine: "Join Our Free Financial Literacy Workshop!",
    purposeOfYourEmail: [
      "Invite to educational workshop",
      "Detail topics to be covered",
      "Provide date, time, and location",
      "Encourage registration"
    ],
    tellUsAboutYou: "[Your Bank/Finance Company] believes in empowering our community through financial education. Established in [Year], we offer resources and support to help you make informed decisions."
  },
  {
    id: 63,
    goalOfTheDraft: "Credit Card Promotion",
    subjectLine: "Apply for Our New [Credit Card Name] and Earn Rewards!",
    purposeOfYourEmail: [
      "Introduce new credit card",
      "Highlight rewards and benefits",
      "Explain application process",
      "Encourage applications"
    ],
    tellUsAboutYou: "[Your Bank/Finance Company] offers a range of credit solutions to meet your needs. Since [Year], we've been dedicated to providing excellent financial products to our [Location] customers."
  },
  {
    id: 64,
    goalOfTheDraft: "Loan Services Promotion",
    subjectLine: "Achieve Your Goals with Our Flexible Loan Options!",
    purposeOfYourEmail: [
      "Promote various loan services",
      "Highlight flexible terms and competitive rates",
      "Provide application information",
      "Encourage consultations"
    ],
    tellUsAboutYou: "At [Your Bank/Finance Company], we understand your financial needs. Since [Year], we've provided [Location] residents with tailored loan solutions to help them achieve their dreams."
  },
  {
    id: 65,
    goalOfTheDraft: "Investment Seminar",
    subjectLine: "Learn How to Grow Your Wealth – Join Our Investment Seminar!",
    purposeOfYourEmail: [
      "Announce investment seminar",
      "Provide details on topics and speakers",
      "Offer registration information",
      "Encourage attendance"
    ],
    tellUsAboutYou: "[Your Bank/Finance Company] is dedicated to helping you grow your wealth. Since [Year], we've offered expert advice and resources to support [Location] investors."
  },

  // --- 4. Hospitality Industry ---
  {
    id: 66,
    goalOfTheDraft: "Promote Seasonal Packages",
    subjectLine: "Experience the Season with Our Exclusive Packages!",
    purposeOfYourEmail: [
      "Introduce seasonal vacation packages",
      "Highlight amenities and activities",
      "Offer special pricing or discounts",
      "Encourage booking"
    ],
    tellUsAboutYou: "At [Your Hotel/Resort Name], we've been welcoming guests to [Location] since [Year]. Our dedication to exceptional service ensures a memorable stay every time."
  },
  {
    id: 67,
    goalOfTheDraft: "Announce Renovations or Upgrades",
    subjectLine: "Discover Our Newly Renovated [Facility/Room]!",
    purposeOfYourEmail: [
      "Announce recent renovations or upgrades",
      "Highlight new features and improvements",
      "Provide before-and-after visuals",
      "Encourage bookings to experience the changes"
    ],
    tellUsAboutYou: "[Your Hotel/Resort Name] is dedicated to enhancing your experience. Since [Year], we've continually upgraded our facilities to provide top-notch accommodations and amenities."
  },
  {
    id: 68,
    goalOfTheDraft: "Host a Special Event",
    subjectLine: "Join Us for [Event Name] at [Hotel/Resort]!",
    purposeOfYourEmail: [
      "Invite to special event",
      "Provide event details (date, time, location)",
      "Highlight performers or activities",
      "Encourage RSVPs and attendance"
    ],
    tellUsAboutYou: "At [Your Hotel/Resort Name], we create unforgettable experiences. Since [Year], we've been bringing [Location] the best in [events/entertainment], ensuring every event is a hit."
  },
  {
    id: 69,
    goalOfTheDraft: "Promote Loyalty Program",
    subjectLine: "Join Our Loyalty Program and Earn Rewards!",
    purposeOfYourEmail: [
      "Introduce loyalty program",
      "Highlight exclusive benefits and rewards",
      "Explain how to join",
      "Encourage enrollment"
    ],
    tellUsAboutYou: "[Your Hotel/Resort Name] values our loyal guests. Since [Year], our loyalty program has been rewarding repeat visits with exclusive perks and unforgettable experiences."
  },
  {
    id: 70,
    goalOfTheDraft: "Celebrate a Milestone",
    subjectLine: "Celebrating [Number] Years of Hospitality!",
    purposeOfYourEmail: [
      "Announce milestone celebration",
      "Reflect on achievements",
      "Thank guests for their support",
      "Share future plans"
    ],
    tellUsAboutYou: "Celebrating [Number] years, [Your Hotel/Resort Name] has been a beacon of hospitality in [Location]. Our journey is a testament to our guests' trust and our team's dedication."
  },

  // --- 5. Beauty & Wellness Industry ---
  {
    id: 71,
    goalOfTheDraft: "Promote New Beauty Treatments",
    subjectLine: "Unveil Your Best Self with Our New Treatments!",
    purposeOfYourEmail: [
      "Introduce new beauty or wellness treatments",
      "Highlight benefits and unique features",
      "Offer introductory discounts or packages",
      "Encourage booking appointments"
    ],
    tellUsAboutYou: "At [Your Salon/Spa Name], beauty and wellness are our passion. Since [Year], we've been providing [Location] with top-quality services in a relaxing environment."
  },
  {
    id: 72,
    goalOfTheDraft: "Seasonal Beauty Tips",
    subjectLine: "Summer Beauty Essentials You Need!",
    purposeOfYourEmail: [
      "Share seasonal beauty tips",
      "Highlight relevant products or services",
      "Provide expert advice",
      "Encourage purchasing or booking"
    ],
    tellUsAboutYou: "[Your Salon/Spa Name] is your go-to destination for all things beauty and wellness in [Location]. Since [Year], our expert team has been dedicated to enhancing your natural beauty."
  },
  {
    id: 73,
    goalOfTheDraft: "Customer Appreciation",
    subjectLine: "Thank You for Being a Loyal Customer!",
    purposeOfYourEmail: [
      "Express gratitude",
      "Highlight customer loyalty",
      "Offer a special discount or gift",
      "Encourage referrals"
    ],
    tellUsAboutYou: "At [Your Salon/Spa Name], our customers are at the heart of everything we do. Since [Year], we've cherished every interaction and strive to provide exceptional service to our [Location] community."
  },
  {
    id: 74,
    goalOfTheDraft: "Promote Membership Program",
    subjectLine: "Join Our Exclusive Membership Program Today!",
    purposeOfYourEmail: [
      "Introduce membership program",
      "Highlight exclusive benefits and perks",
      "Provide membership options and pricing",
      "Encourage sign-ups"
    ],
    tellUsAboutYou: "[Your Salon/Spa Name] values our loyal customers. Since [Year], we've been offering exceptional [services] to the [Location] community, and our membership program is designed to reward your continued support."
  },
  {
    id: 75,
    goalOfTheDraft: "Introduce Wellness Workshops",
    subjectLine: "Enhance Your Well-being with Our New Workshops!",
    purposeOfYourEmail: [
      "Announce new wellness workshops",
      "Detail workshop topics and benefits",
      "Provide schedule and registration info",
      "Encourage participation"
    ],
    tellUsAboutYou: "At [Your Salon/Spa Name], we believe in holistic wellness. Since [Year], we've been committed to providing [Location] residents with comprehensive wellness programs that nurture both body and mind."
  },

  // --- 6. Technology & Software Industry ---
  {
    id: 76,
    goalOfTheDraft: "Launch New Software Update",
    subjectLine: "Upgrade to Our Latest [Software Name] Version!",
    purposeOfYourEmail: [
      "Announce new software update",
      "Highlight new features and improvements",
      "Provide download or upgrade instructions",
      "Encourage user feedback"
    ],
    tellUsAboutYou: "Since [Year], [Your Company Name] has been at the forefront of technology innovation in [Location]. Our mission is to provide cutting-edge software solutions that empower businesses and individuals."
  },
  {
    id: 77,
    goalOfTheDraft: "Offer Free Trial",
    subjectLine: "Experience [Software Name] Free for 30 Days!",
    purposeOfYourEmail: [
      "Introduce free trial offer",
      "Highlight key features and benefits",
      "Provide sign-up instructions",
      "Encourage immediate registration"
    ],
    tellUsAboutYou: "[Your Company Name] is dedicated to delivering top-quality software solutions since [Year]. Based in [Location], we strive to help our users achieve more with intuitive and powerful tools."
  },
  {
    id: 78,
    goalOfTheDraft: "Webinar Invitation",
    subjectLine: "Join Our Webinar: [Webinar Topic]!",
    purposeOfYourEmail: [
      "Invite to educational webinar",
      "Detail topics and speakers",
      "Provide date and time",
      "Encourage registration"
    ],
    tellUsAboutYou: "At [Your Company Name], we are committed to sharing knowledge and best practices in [industry]. Since [Year], we've been hosting webinars and training sessions to educate and engage the [Location] community."
  },
  {
    id: 79,
    goalOfTheDraft: "Share Customer Success Stories",
    subjectLine: "See How [Customer Name] Thrived with [Software Name]!",
    purposeOfYourEmail: [
      "Share success stories of customers",
      "Highlight how your software made a difference",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Company Name] prides itself on helping our customers succeed. Since [Year], we've been dedicated to providing [Location] businesses with the tools they need to thrive."
  },
  {
    id: 80,
    goalOfTheDraft: "Promote Integration Features",
    subjectLine: "Seamlessly Integrate [Software Name] with Your Tools!",
    purposeOfYourEmail: [
      "Highlight integration capabilities",
      "Explain benefits of seamless workflows",
      "Provide setup instructions",
      "Encourage adoption and usage"
    ],
    tellUsAboutYou: "At [Your Company Name], we believe in creating software that works harmoniously with your existing tools. Since [Year], we've been helping [Location] businesses streamline their operations with easy integrations."
  },

  // --- 7. Healthcare Industry ---
  {
    id: 81,
    goalOfTheDraft: "Promote Health Services",
    subjectLine: "Comprehensive Healthcare Services Now Available!",
    purposeOfYourEmail: [
      "Introduce new healthcare services",
      "Highlight benefits and expertise",
      "Provide information on how to access services",
      "Encourage scheduling appointments"
    ],
    tellUsAboutYou: "At [Your Clinic/Hospital Name], we prioritize your health and well-being. Since [Year], our dedicated team in [Location] has been providing top-notch medical services with compassion and expertise."
  },
  {
    id: 82,
    goalOfTheDraft: "Health Awareness Campaign",
    subjectLine: "Join Our [Health Campaign] for a Healthier You!",
    purposeOfYourEmail: [
      "Announce health awareness campaign",
      "Provide information and resources",
      "Highlight community involvement",
      "Encourage participation and sharing"
    ],
    tellUsAboutYou: "[Your Clinic/Hospital Name] is committed to promoting health and wellness in [Location]. Since [Year], we've been actively involved in community health initiatives and education."
  },
  {
    id: 83,
    goalOfTheDraft: "Introduce Telehealth Services",
    subjectLine: "Access Healthcare Anytime with Our Telehealth Services!",
    purposeOfYourEmail: [
      "Announce telehealth services",
      "Highlight convenience and accessibility",
      "Provide information on how to use telehealth",
      "Encourage booking virtual appointments"
    ],
    tellUsAboutYou: "At [Your Clinic/Hospital Name], we're embracing modern technology to enhance patient care. Since [Year], our telehealth services have provided [Location] residents with easy access to healthcare professionals."
  },
  {
    id: 84,
    goalOfTheDraft: "Patient Testimonials",
    subjectLine: "Hear from Our Satisfied Patients!",
    purposeOfYourEmail: [
      "Share positive patient testimonials",
      "Highlight patient satisfaction",
      "Encourage others to share their experiences",
      "Build trust and credibility"
    ],
    tellUsAboutYou: "[Your Clinic/Hospital Name] values every patient story. Since [Year], our commitment to compassionate care has earned us the trust and loyalty of the [Location] community."
  },
  {
    id: 85,
    goalOfTheDraft: "Promote Wellness Programs",
    subjectLine: "Enhance Your Well-being with Our Wellness Programs!",
    purposeOfYourEmail: [
      "Introduce wellness programs",
      "Highlight program benefits",
      "Provide enrollment information",
      "Encourage participation"
    ],
    tellUsAboutYou: "At [Your Clinic/Hospital Name], we believe in holistic health. Since [Year], our wellness programs have been designed to support the overall well-being of our [Location] community."
  },

  // --- 8. Real Estate Industry ---
  {
    id: 86,
    goalOfTheDraft: "Promote New Property Listings",
    subjectLine: "Explore Our Latest Property Listings in [Location]!",
    purposeOfYourEmail: [
      "Announce new property listings",
      "Highlight key features and amenities",
      "Provide virtual tour links or schedule viewings",
      "Encourage contacting an agent"
    ],
    tellUsAboutYou: "With years of experience in the [Location] real estate market, [Your Real Estate Agency] is dedicated to finding your perfect home. Since [Year], we've helped countless clients navigate their real estate journeys."
  },
  {
    id: 87,
    goalOfTheDraft: "Host Open House Event",
    subjectLine: "Join Us for an Open House at [Property Address]!",
    purposeOfYourEmail: [
      "Invite to open house event",
      "Provide event details (date, time, location)",
      "Highlight property features",
      "Encourage RSVPs or walk-ins"
    ],
    tellUsAboutYou: "[Your Real Estate Agency] has been serving the [Location] community since [Year]. Our commitment to excellence and personalized service ensures a smooth and successful home-buying experience."
  },
  {
    id: 88,
    goalOfTheDraft: "Promote Real Estate Services",
    subjectLine: "Find Your Dream Home with [Your Real Estate Agency]!",
    purposeOfYourEmail: [
      "Promote real estate services",
      "Highlight expertise and local knowledge",
      "Provide contact information",
      "Encourage consultations"
    ],
    tellUsAboutYou: "At [Your Real Estate Agency], we understand the [Location] market inside and out. Since [Year], our dedicated agents have been helping clients find their perfect homes with personalized service."
  },
  {
    id: 89,
    goalOfTheDraft: "Share Market Insights",
    subjectLine: "Stay Informed with Our Latest Real Estate Market Insights!",
    purposeOfYourEmail: [
      "Share latest market trends",
      "Provide analysis and forecasts",
      "Highlight opportunities",
      "Encourage reaching out for personalized advice"
    ],
    tellUsAboutYou: "[Your Real Estate Agency] is committed to keeping our clients informed. Since [Year], we've provided [Location] residents with up-to-date market insights to help them make informed real estate decisions."
  },
  {
    id: 90,
    goalOfTheDraft: "Client Success Stories",
    subjectLine: "How We Helped [Client Name] Find Their Perfect Home!",
    purposeOfYourEmail: [
      "Share success stories of clients",
      "Highlight how your agency made a difference",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Real Estate Agency] prides itself on client satisfaction. Since [Year], we've been dedicated to helping [Location] residents achieve their real estate goals with professionalism and care."
  },

  // --- 9. Non-Profit Organizations ---
  {
    id: 91,
    goalOfTheDraft: "Fundraising Campaign",
    subjectLine: "Support Our Mission – Donate Today!",
    purposeOfYourEmail: [
      "Introduce fundraising campaign",
      "Explain the cause and impact",
      "Provide donation methods",
      "Encourage sharing and participation"
    ],
    tellUsAboutYou: "[Your Non-Profit Name] has been dedicated to [mission] since [Year]. Based in [Location], our team works tirelessly to make a positive impact in our community and beyond."
  },
  {
    id: 92,
    goalOfTheDraft: "Volunteer Recruitment",
    subjectLine: "Join Our Team of Volunteers!",
    purposeOfYourEmail: [
      "Invite to volunteer opportunities",
      "Explain roles and responsibilities",
      "Highlight the benefits of volunteering",
      "Provide sign-up instructions"
    ],
    tellUsAboutYou: "At [Your Non-Profit Name], we believe in the power of community. Since [Year], we've relied on passionate volunteers in [Location] to help us achieve our goals and support those in need."
  },
  {
    id: 93,
    goalOfTheDraft: "Awareness Campaign",
    subjectLine: "Raise Awareness for [Cause] with Us!",
    purposeOfYourEmail: [
      "Promote awareness for a specific cause",
      "Provide information and resources",
      "Highlight the importance of the cause",
      "Encourage sharing and involvement"
    ],
    tellUsAboutYou: "[Your Non-Profit Name] is committed to [cause]. Since [Year], we've been working in [Location] to bring about positive change and support those affected by [cause]."
  },
  {
    id: 94,
    goalOfTheDraft: "Event Invitation",
    subjectLine: "You're Invited to [Event Name]!",
    purposeOfYourEmail: [
      "Invite to fundraising or awareness event",
      "Provide event details (date, time, location)",
      "Highlight activities and speakers",
      "Encourage RSVPs or participation"
    ],
    tellUsAboutYou: "At [Your Non-Profit Name], we host events to support our mission and engage with the [Location] community. Since [Year], we've organized numerous events that bring people together for a cause."
  },
  {
    id: 95,
    goalOfTheDraft: "Impact Report",
    subjectLine: "See the Impact of Your Support in [Year]!",
    purposeOfYourEmail: [
      "Share annual impact report",
      "Highlight key achievements and statistics",
      "Express gratitude to supporters",
      "Encourage continued support"
    ],
    tellUsAboutYou: "[Your Non-Profit Name] is proud to share our achievements for [Year]. Since [Year], we've been dedicated to [mission] in [Location], and your support has been instrumental in our success."
  },

  // --- 10. Manufacturing Industry ---
  {
    id: 96,
    goalOfTheDraft: "Promote New Product Line",
    subjectLine: "Introducing Our New [Product Line]!",
    purposeOfYourEmail: [
      "Announce new product line",
      "Highlight innovative features and benefits",
      "Provide information on availability",
      "Encourage orders or inquiries"
    ],
    tellUsAboutYou: "[Your Manufacturing Company] has been producing high-quality [products] since [Year]. Located in [Location], we are committed to excellence and innovation in every product we create."
  },
  {
    id: 97,
    goalOfTheDraft: "Share Manufacturing Milestones",
    subjectLine: "Celebrating [Milestone] Years of Excellence!",
    purposeOfYourEmail: [
      "Announce company milestone",
      "Reflect on achievements and growth",
      "Thank customers and partners",
      "Share future plans"
    ],
    tellUsAboutYou: "Founded in [Year], [Your Manufacturing Company] has grown from a small workshop to a leading manufacturer in [Location]. Our dedication to quality and customer satisfaction drives our success."
  },
  {
    id: 98,
    goalOfTheDraft: "Factory Tour Invitation",
    subjectLine: "Experience Our Manufacturing Process – Join Our Factory Tour!",
    purposeOfYourEmail: [
      "Invite to factory tour",
      "Provide tour details (date, time, location)",
      "Highlight unique manufacturing processes",
      "Build transparency and trust"
    ],
    tellUsAboutYou: "At [Your Manufacturing Company], transparency is key. Since [Year], we've been dedicated to showcasing our meticulous manufacturing processes to ensure the highest quality for [Location] clients."
  },
  {
    id: 99,
    goalOfTheDraft: "Promote Sustainability Initiatives",
    subjectLine: "Our Commitment to Sustainable Manufacturing!",
    purposeOfYourEmail: [
      "Share sustainability practices",
      "Highlight specific initiatives",
      "Explain benefits to the environment and community",
      "Encourage customer support for sustainable products"
    ],
    tellUsAboutYou: "[Your Manufacturing Company] is committed to sustainability. Since [Year], we've been creating eco-friendly products that help [Location] businesses reduce their environmental footprint."
  },
  {
    id: 100,
    goalOfTheDraft: "Customer Testimonials",
    subjectLine: "Hear How [Customer Name] Boosted Their Business with Us!",
    purposeOfYourEmail: [
      "Share positive customer testimonials",
      "Highlight successful projects or partnerships",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Manufacturing Company] values every client relationship. Since [Year], our commitment to quality and personalized service has earned us the trust and loyalty of the [Location] business community."
  },

  // --- 11. IT Services ---
  {
    id: 101,
    goalOfTheDraft: "Promote IT Services",
    subjectLine: "Optimize Your Business with Our IT Solutions!",
    purposeOfYourEmail: [
      "Introduce new IT services",
      "Highlight benefits and features",
      "Provide case studies or testimonials",
      "Encourage scheduling a consultation"
    ],
    tellUsAboutYou: "Since [Year], [Your IT Company] has been empowering businesses in [Location] with cutting-edge technology solutions. Our expert team is dedicated to helping you achieve your IT goals efficiently."
  },
  {
    id: 102,
    goalOfTheDraft: "Launch Mobile App",
    subjectLine: "Experience Convenience with Our New Mobile App!",
    purposeOfYourEmail: [
      "Announce mobile app launch",
      "Highlight key features and benefits",
      "Provide download links",
      "Encourage user feedback"
    ],
    tellUsAboutYou: "[Your Company Name] is committed to enhancing user experiences through innovation. Since [Year], we've been developing solutions that make life easier for our [Location] customers."
  },
  {
    id: 103,
    goalOfTheDraft: "Share Tech Tips",
    subjectLine: "Top 5 Tips to Enhance Your Cybersecurity!",
    purposeOfYourEmail: [
      "Provide tech or cybersecurity tips",
      "Position your company as a helpful resource",
      "Encourage engagement with content",
      "Link to relevant services or blog"
    ],
    tellUsAboutYou: "At [Your IT Company], we prioritize your digital security. Since [Year], we've been dedicated to providing [Location] businesses with the best IT solutions and expert advice to keep you safe online."
  },
  {
    id: 104,
    goalOfTheDraft: "Offer Free Consultation",
    subjectLine: "Get a Free IT Consultation Today!",
    purposeOfYourEmail: [
      "Introduce free consultation offer",
      "Highlight benefits and what to expect",
      "Provide scheduling instructions",
      "Encourage immediate booking"
    ],
    tellUsAboutYou: "[Your IT Company] is here to support your business's technological needs. Since [Year], we've been providing [Location] companies with reliable IT services and expert guidance."
  },
  {
    id: 105,
    goalOfTheDraft: "Announce Webinar",
    subjectLine: "Join Our Webinar on Cloud Computing Trends!",
    purposeOfYourEmail: [
      "Invite to educational webinar",
      "Detail topics and speakers",
      "Provide date and time",
      "Encourage registration"
    ],
    tellUsAboutYou: "At [Your IT Company], we stay ahead of technology trends to serve our clients better. Since [Year], we've been sharing our knowledge through webinars and training sessions in [Location]."
  },

  // --- 12. E-commerce Industry ---
  {
    id: 106,
    goalOfTheDraft: "Promote Flash Sale",
    subjectLine: "24-Hour Flash Sale – Don’t Miss Out!",
    purposeOfYourEmail: [
      "Announce a limited-time flash sale",
      "Highlight key deals and discounts",
      "Create urgency with countdown timers",
      "Encourage immediate purchases"
    ],
    tellUsAboutYou: "[Your E-commerce Store] has been providing [products/services] to [Location] since [Year]. Our commitment to quality and customer satisfaction drives our ongoing success."
  },
  {
    id: 107,
    goalOfTheDraft: "Launch New Collection",
    subjectLine: "Explore Our New [Season] Collection Now!",
    purposeOfYourEmail: [
      "Introduce new product collection",
      "Showcase featured items with images",
      "Offer exclusive early access",
      "Encourage browsing and purchasing"
    ],
    tellUsAboutYou: "At [Your E-commerce Store], we curate the best [products/services] to meet your needs. Since [Year], we've been delivering exceptional online shopping experiences to customers in [Location]."
  },
  {
    id: 108,
    goalOfTheDraft: "Cart Abandonment Reminder",
    subjectLine: "Forgot Something? Complete Your Purchase Now!",
    purposeOfYourEmail: [
      "Remind customers of abandoned carts",
      "Highlight items left in the cart",
      "Offer incentives to complete purchase",
      "Provide easy link to cart"
    ],
    tellUsAboutYou: "At [Your E-commerce Store], we value your shopping experience. Since [Year], we've been providing [Location] customers with a seamless and enjoyable online shopping journey."
  },
  {
    id: 109,
    goalOfTheDraft: "Customer Loyalty Program",
    subjectLine: "Join Our Loyalty Program and Earn Rewards!",
    purposeOfYourEmail: [
      "Introduce loyalty program",
      "Highlight exclusive benefits and rewards",
      "Explain how to join",
      "Encourage enrollment"
    ],
    tellUsAboutYou: "[Your E-commerce Store] thrives on customer loyalty. Since [Year], we've been rewarding our [Location] customers with exclusive offers and points for every purchase through our loyalty program."
  },
  {
    id: 110,
    goalOfTheDraft: "Promote Gift Guides",
    subjectLine: "Your Ultimate [Holiday/Event] Gift Guide!",
    purposeOfYourEmail: [
      "Provide curated gift suggestions",
      "Highlight various categories",
      "Link to products",
      "Encourage easy gifting"
    ],
    tellUsAboutYou: "Finding the perfect gift is easy with [Your E-commerce Store]. Since [Year], we've curated gift guides to help our [Location] community choose thoughtful and meaningful presents for any occasion."
  },

  // --- 13. Legal Services ---
  {
    id: 111,
    goalOfTheDraft: "Promote Legal Consultation",
    subjectLine: "Get Expert Legal Advice with a Free Consultation!",
    purposeOfYourEmail: [
      "Introduce free consultation offer",
      "Highlight areas of expertise",
      "Provide scheduling information",
      "Encourage booking appointments"
    ],
    tellUsAboutYou: "At [Your Law Firm], we provide trusted legal services to [Location]. Since [Year], our experienced attorneys have been dedicated to helping clients navigate complex legal matters with confidence."
  },
  {
    id: 112,
    goalOfTheDraft: "Share Legal Tips",
    subjectLine: "Top 5 Tips to Protect Your Business Legally!",
    purposeOfYourEmail: [
      "Provide valuable legal tips",
      "Position your firm as a helpful resource",
      "Encourage engagement with content",
      "Link to relevant services or blog"
    ],
    tellUsAboutYou: "[Your Law Firm] is committed to empowering [Location] businesses with the knowledge to protect their interests. Since [Year], we've been offering expert legal advice and support."
  },
  {
    id: 113,
    goalOfTheDraft: "Announce Webinar",
    subjectLine: "Join Our Webinar: Understanding Contract Law!",
    purposeOfYourEmail: [
      "Invite to educational webinar",
      "Detail topics and speakers",
      "Provide date and time",
      "Encourage registration"
    ],
    tellUsAboutYou: "At [Your Law Firm], we stay at the forefront of legal developments to serve our clients better. Since [Year], we've been hosting webinars and seminars to educate and engage the [Location] community."
  },
  {
    id: 114,
    goalOfTheDraft: "Client Testimonials",
    subjectLine: "Hear from Our Satisfied Clients!",
    purposeOfYourEmail: [
      "Share positive client testimonials",
      "Highlight successful cases",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Law Firm] values every client relationship. Since [Year], our commitment to excellence and personalized service has earned us the trust and loyalty of the [Location] community."
  },
  {
    id: 115,
    goalOfTheDraft: "Legal Updates Newsletter",
    subjectLine: "Stay Informed with Our Latest Legal Updates!",
    purposeOfYourEmail: [
      "Share latest legal news and updates",
      "Provide analysis and insights",
      "Highlight how changes impact clients",
      "Encourage reaching out for personalized advice"
    ],
    tellUsAboutYou: "[Your Law Firm] is dedicated to keeping our clients informed. Since [Year], we've been providing [Location] residents with up-to-date legal insights to help them make informed decisions."
  },

  // --- 14. Construction Industry ---
  {
    id: 116,
    goalOfTheDraft: "Promote New Construction Projects",
    subjectLine: "Discover Our Latest [Project Type] in [Location]!",
    purposeOfYourEmail: [
      "Announce new construction project",
      "Highlight key features and benefits",
      "Provide project timeline and details",
      "Encourage inquiries or investments"
    ],
    tellUsAboutYou: "[Your Construction Company] has been building dreams since [Year]. Based in [Location], we specialize in [types of projects], ensuring quality and excellence in every build."
  },
  {
    id: 117,
    goalOfTheDraft: "Share Project Milestones",
    subjectLine: "Celebrating Milestones on Our [Project Name]!",
    purposeOfYourEmail: [
      "Share progress on construction projects",
      "Highlight achievements and milestones",
      "Thank clients and partners",
      "Encourage continued support"
    ],
    tellUsAboutYou: "At [Your Construction Company], every project is a step towards excellence. Since [Year], we've been dedicated to bringing [Location] innovative and high-quality construction projects to life."
  },
  {
    id: 118,
    goalOfTheDraft: "Promote Sustainable Building Practices",
    subjectLine: "Building a Greener Future with Our Sustainable Practices!",
    purposeOfYourEmail: [
      "Share sustainable building practices",
      "Highlight eco-friendly materials and methods",
      "Explain benefits to environment and community",
      "Encourage support for sustainable projects"
    ],
    tellUsAboutYou: "[Your Construction Company] is committed to sustainability. Since [Year], we've integrated eco-friendly practices in our [Location] projects to reduce our environmental impact and promote a greener future."
  },
  {
    id: 119,
    goalOfTheDraft: "Announce Open House for Completed Projects",
    subjectLine: "Visit Our Completed [Project Type] – Open House on [Date]!",
    purposeOfYourEmail: [
      "Invite to open house event for completed projects",
      "Provide event details (date, time, location)",
      "Highlight features of the project",
      "Encourage attendance and feedback"
    ],
    tellUsAboutYou: "At [Your Construction Company], we take pride in our completed projects. Since [Year], we've been transforming [Location] with our commitment to quality and innovation."
  },
  {
    id: 120,
    goalOfTheDraft: "Customer Testimonials",
    subjectLine: "Hear What Our Clients Have to Say!",
    purposeOfYourEmail: [
      "Share positive client testimonials",
      "Highlight successful projects",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Construction Company] values every client relationship. Since [Year], our dedication to excellence has earned us the trust and loyalty of the [Location] community."
  },

  // --- 15. Transportation & Logistics Industry ---
  {
    id: 121,
    goalOfTheDraft: "Promote Shipping Services",
    subjectLine: "Reliable Shipping Solutions for Your Business!",
    purposeOfYourEmail: [
      "Introduce shipping services",
      "Highlight benefits and features",
      "Provide information on rates and coverage",
      "Encourage inquiries or sign-ups"
    ],
    tellUsAboutYou: "[Your Logistics Company] has been delivering excellence since [Year]. Based in [Location], we specialize in reliable and efficient shipping solutions for businesses of all sizes."
  },
  {
    id: 122,
    goalOfTheDraft: "Share Industry Insights",
    subjectLine: "Stay Ahead with Our Latest Logistics Trends!",
    purposeOfYourEmail: [
      "Share latest industry trends and insights",
      "Provide analysis and forecasts",
      "Highlight opportunities",
      "Encourage reaching out for personalized advice"
    ],
    tellUsAboutYou: "[Your Logistics Company] is dedicated to keeping our clients informed. Since [Year], we've been providing [Location] businesses with up-to-date logistics insights to help them navigate the ever-changing market."
  },
  {
    id: 123,
    goalOfTheDraft: "Promote Fleet Expansion",
    subjectLine: "Expanding Our Fleet to Serve You Better!",
    purposeOfYourEmail: [
      "Announce fleet expansion",
      "Highlight new vehicles or capabilities",
      "Explain benefits to customers",
      "Encourage using enhanced services"
    ],
    tellUsAboutYou: "At [Your Logistics Company], growth is driven by our commitment to service. Since [Year], we've been expanding our fleet to provide [Location] businesses with even more reliable and efficient transportation options."
  },
  {
    id: 124,
    goalOfTheDraft: "Offer Special Rates for New Clients",
    subjectLine: "New Clients: Enjoy Special Shipping Rates!",
    purposeOfYourEmail: [
      "Introduce special rates for new clients",
      "Highlight savings and benefits",
      "Provide information on how to avail",
      "Encourage sign-ups or inquiries"
    ],
    tellUsAboutYou: "[Your Logistics Company] welcomes new clients with open arms. Since [Year], we've been providing [Location] businesses with cost-effective and dependable shipping solutions tailored to their needs."
  },
  {
    id: 125,
    goalOfTheDraft: "Customer Appreciation Event",
    subjectLine: "Join Us for Our Annual Customer Appreciation Day!",
    purposeOfYourEmail: [
      "Invite to appreciation event",
      "Provide event details (date, time, location)",
      "Highlight activities and giveaways",
      "Encourage RSVPs"
    ],
    tellUsAboutYou: "At [Your Logistics Company], our customers are our priority. Since [Year], we've hosted events to thank the [Location] community for their loyalty and support."
  },

  // --- 16. Agriculture Industry ---
  {
    id: 126,
    goalOfTheDraft: "Promote New Agricultural Products",
    subjectLine: "Introducing Our New [Product Name] for a Bountiful Harvest!",
    purposeOfYourEmail: [
      "Announce new agricultural products",
      "Highlight benefits and features",
      "Provide information on availability",
      "Encourage purchases or inquiries"
    ],
    tellUsAboutYou: "[Your Agriculture Company] has been supporting farmers since [Year]. Based in [Location], we specialize in high-quality [agricultural products/services] to enhance your farming operations."
  },
  {
    id: 127,
    goalOfTheDraft: "Share Farming Tips",
    subjectLine: "Top 5 Tips for a Successful [Crop] Season!",
    purposeOfYourEmail: [
      "Provide valuable farming tips",
      "Position your company as a helpful resource",
      "Encourage engagement with content",
      "Link to relevant products or blog"
    ],
    tellUsAboutYou: "At [Your Agriculture Company], we are committed to the success of our farmers. Since [Year], we've been providing [Location] agricultural communities with the resources and expertise needed for optimal yields."
  },
  {
    id: 128,
    goalOfTheDraft: "Announce Community Outreach Program",
    subjectLine: "Join Our Community Outreach Program for Sustainable Farming!",
    purposeOfYourEmail: [
      "Introduce community outreach initiatives",
      "Highlight sustainable farming practices",
      "Provide information on how to get involved",
      "Encourage participation and support"
    ],
    tellUsAboutYou: "[Your Agriculture Company] is dedicated to fostering sustainable farming in [Location]. Since [Year], our outreach programs have empowered local farmers with the knowledge and tools to thrive."
  },
  {
    id: 129,
    goalOfTheDraft: "Promote Agricultural Workshops",
    subjectLine: "Enhance Your Farming Skills with Our Workshops!",
    purposeOfYourEmail: [
      "Announce agricultural workshops",
      "Detail workshop topics and benefits",
      "Provide schedule and registration info",
      "Encourage participation"
    ],
    tellUsAboutYou: "At [Your Agriculture Company], education and innovation go hand in hand. Since [Year], we've been hosting workshops in [Location] to help farmers adopt the latest techniques and technologies."
  },
  {
    id: 130,
    goalOfTheDraft: "Customer Testimonials",
    subjectLine: "Hear How [Customer Name] Boosted Their Yield with Us!",
    purposeOfYourEmail: [
      "Share positive customer testimonials",
      "Highlight successful partnerships",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Agriculture Company] values every customer relationship. Since [Year], our commitment to quality and service has earned us the trust and loyalty of the [Location] farming community."
  },

  // --- 17. Entertainment & Media Industry ---
  {
    id: 131,
    goalOfTheDraft: "Promote Upcoming Event",
    subjectLine: "Don't Miss [Event Name] on [Date]!",
    purposeOfYourEmail: [
      "Announce upcoming event",
      "Provide event details (date, time, location)",
      "Highlight performers or activities",
      "Encourage ticket purchases"
    ],
    tellUsAboutYou: "At [Your Entertainment Company], we create unforgettable experiences. Since [Year], we've been bringing [Location] the best in [events/entertainment], ensuring every event is a hit."
  },
  {
    id: 132,
    goalOfTheDraft: "Share Behind-the-Scenes Content",
    subjectLine: "A Sneak Peek Behind the Scenes of [Production/Event]!",
    purposeOfYourEmail: [
      "Provide behind-the-scenes look",
      "Highlight unique aspects of production",
      "Share stories or interviews",
      "Build anticipation for the event/product"
    ],
    tellUsAboutYou: "[Your Entertainment Company] is dedicated to excellence in [Location]. Since [Year], we've been producing top-tier [events/productions], ensuring our audience enjoys the best entertainment experience."
  },
  {
    id: 133,
    goalOfTheDraft: "Announce New Content Release",
    subjectLine: "New [Content Type] Released – Watch Now!",
    purposeOfYourEmail: [
      "Announce release of new content (e.g., movie, episode, album)",
      "Highlight reviews or endorsements",
      "Provide viewing or listening links",
      "Encourage sharing and feedback"
    ],
    tellUsAboutYou: "At [Your Entertainment Company], we are passionate about creating engaging content. Since [Year], we've been delivering high-quality [movies/episodes/albums] to our [Location] audience and beyond."
  },
  {
    id: 134,
    goalOfTheDraft: "Promote Subscription Service",
    subjectLine: "Unlock Exclusive Content with Our Subscription!",
    purposeOfYourEmail: [
      "Introduce subscription service",
      "Highlight exclusive benefits and content",
      "Provide subscription options and pricing",
      "Encourage sign-ups"
    ],
    tellUsAboutYou: "[Your Entertainment Company] offers exclusive content to our dedicated fans. Since [Year], our subscription service has provided [Location] audiences with unique and engaging entertainment options."
  },
  {
    id: 135,
    goalOfTheDraft: "Customer Appreciation Event",
    subjectLine: "Join Us for Our Annual Customer Appreciation Night!",
    purposeOfYourEmail: [
      "Invite to appreciation event",
      "Provide event details (date, time, location)",
      "Highlight activities and giveaways",
      "Encourage RSVPs"
    ],
    tellUsAboutYou: "At [Your Entertainment Company], our customers are at the heart of our success. Since [Year], we've hosted events to thank our [Location] community for their unwavering support."
  },

  // --- 18. Sports & Recreation Industry ---
  {
    id: 136,
    goalOfTheDraft: "Promote New Sports Programs",
    subjectLine: "Join Our New [Sport] Programs Today!",
    purposeOfYourEmail: [
      "Introduce new sports programs",
      "Highlight benefits and features",
      "Provide registration information",
      "Encourage sign-ups"
    ],
    tellUsAboutYou: "At [Your Sports Organization], we are passionate about promoting sports and recreation. Since [Year], we've been offering top-notch [sport] programs to the [Location] community."
  },
  {
    id: 137,
    goalOfTheDraft: "Announce Upcoming Tournament",
    subjectLine: "Get Ready for the [Tournament Name] on [Date]!",
    purposeOfYourEmail: [
      "Announce upcoming tournament",
      "Provide event details (date, time, location)",
      "Highlight participating teams or players",
      "Encourage registrations and attendance"
    ],
    tellUsAboutYou: "[Your Sports Organization] is dedicated to fostering competitive spirit and athletic excellence. Since [Year], we've been organizing [sports] tournaments that bring the [Location] community together."
  },
  {
    id: 138,
    goalOfTheDraft: "Share Training Tips",
    subjectLine: "Improve Your Game with These Top Training Tips!",
    purposeOfYourEmail: [
      "Provide valuable training tips",
      "Position your organization as a helpful resource",
      "Encourage engagement with content",
      "Link to relevant programs or services"
    ],
    tellUsAboutYou: "At [Your Sports Organization], we are committed to the growth and development of our athletes. Since [Year], we've been providing [Location] sports enthusiasts with the tools and knowledge to excel."
  },
  {
    id: 139,
    goalOfTheDraft: "Promote Membership Program",
    subjectLine: "Become a Member and Enjoy Exclusive Benefits!",
    purposeOfYourEmail: [
      "Introduce membership program",
      "Highlight exclusive benefits and rewards",
      "Provide membership options and pricing",
      "Encourage sign-ups"
    ],
    tellUsAboutYou: "[Your Sports Organization] values our members. Since [Year], our membership program has offered [Location] sports enthusiasts exclusive access to events, training sessions, and special discounts."
  },
  {
    id: 140,
    goalOfTheDraft: "Customer Testimonials",
    subjectLine: "Hear What Our Happy Members Are Saying!",
    purposeOfYourEmail: [
      "Share positive member testimonials",
      "Highlight successful programs and events",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Sports Organization] prides itself on member satisfaction. Since [Year], our commitment to excellence and community spirit has earned us the trust and loyalty of the [Location] sports community."
  },

  // --- 19. Art & Culture Industry ---
  {
    id: 141,
    goalOfTheDraft: "Promote Upcoming Exhibition",
    subjectLine: "Experience [Exhibition Name] – Now Open!",
    purposeOfYourEmail: [
      "Announce upcoming or ongoing exhibition",
      "Provide exhibition details (dates, location, featured artists)",
      "Highlight unique aspects or themes",
      "Encourage attendance and participation"
    ],
    tellUsAboutYou: "At [Your Art Gallery/Museum], we celebrate creativity and culture. Since [Year], we've been showcasing diverse exhibitions that enrich the [Location] community and inspire visitors."
  },
  {
    id: 142,
    goalOfTheDraft: "Announce Workshop or Class",
    subjectLine: "Join Our [Art/Culture] Workshop on [Date]!",
    purposeOfYourEmail: [
      "Announce workshop or class",
      "Provide details on topics and instructors",
      "Highlight benefits and learning outcomes",
      "Encourage registrations"
    ],
    tellUsAboutYou: "[Your Art Gallery/Museum] is dedicated to fostering artistic expression and cultural appreciation. Since [Year], we've offered workshops and classes that engage and educate the [Location] community."
  },
  {
    id: 143,
    goalOfTheDraft: "Share Artist Spotlight",
    subjectLine: "Meet [Artist Name]: Spotlight on Creativity!",
    purposeOfYourEmail: [
      "Introduce featured artist",
      "Share artist's background and works",
      "Highlight their exhibition or collaboration",
      "Encourage visiting their exhibit or purchasing art"
    ],
    tellUsAboutYou: "[Your Art Gallery/Museum] is proud to feature talented artists who contribute to our vibrant cultural scene. Since [Year], we've been committed to showcasing the best of [Location] and beyond."
  },
  {
    id: 144,
    goalOfTheDraft: "Promote Membership Program",
    subjectLine: "Become a Member and Support the Arts!",
    purposeOfYourEmail: [
      "Introduce membership program",
      "Highlight exclusive benefits and perks",
      "Provide membership options and pricing",
      "Encourage sign-ups"
    ],
    tellUsAboutYou: "[Your Art Gallery/Museum] values our members. Since [Year], our membership program has offered [Location] art enthusiasts exclusive access to events, previews, and special discounts."
  },
  {
    id: 145,
    goalOfTheDraft: "Customer Testimonials",
    subjectLine: "Hear What Our Visitors Are Saying!",
    purposeOfYourEmail: [
      "Share positive visitor testimonials",
      "Highlight memorable experiences",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Art Gallery/Museum] prides itself on visitor satisfaction. Since [Year], our commitment to excellence and engaging exhibitions has earned us the trust and loyalty of the [Location] community."
  },

  // --- 20. Media & Publishing Industry ---
  {
    id: 146,
    goalOfTheDraft: "Promote New Book Release",
    subjectLine: "Discover the Latest Release: [Book Title]!",
    purposeOfYourEmail: [
      "Announce new book release",
      "Provide details about the book",
      "Highlight reviews or endorsements",
      "Encourage pre-orders or purchases"
    ],
    tellUsAboutYou: "[Your Publishing House] has been bringing great stories to readers since [Year]. Based in [Location], we are committed to publishing diverse and compelling works that inspire and entertain."
  },
  {
    id: 147,
    goalOfTheDraft: "Announce Author Event",
    subjectLine: "Join Us for a Live Q&A with [Author Name]!",
    purposeOfYourEmail: [
      "Invite to author event",
      "Provide event details (date, time, location)",
      "Highlight author’s achievements",
      "Encourage RSVPs and attendance"
    ],
    tellUsAboutYou: "[Your Publishing House] is dedicated to fostering a love for reading and literature. Since [Year], we've been hosting events that connect authors with their readers in [Location]."
  },
  {
    id: 148,
    goalOfTheDraft: "Share Reading Tips or Book Recommendations",
    subjectLine: "Top 5 Must-Read Books for [Season/Topic]!",
    purposeOfYourEmail: [
      "Provide book recommendations",
      "Highlight genres or themes",
      "Encourage purchasing or borrowing",
      "Share insights or reviews"
    ],
    tellUsAboutYou: "At [Your Publishing House], we believe in the power of stories. Since [Year], we've been curating and publishing books that enrich the [Location] community and beyond."
  },
  {
    id: 149,
    goalOfTheDraft: "Promote Subscription Service",
    subjectLine: "Subscribe to Our Book Club and Get Exclusive Benefits!",
    purposeOfYourEmail: [
      "Introduce book club subscription",
      "Highlight exclusive benefits and perks",
      "Provide subscription options and pricing",
      "Encourage sign-ups"
    ],
    tellUsAboutYou: "[Your Publishing House] values our readers. Since [Year], our book club subscription has offered [Location] book enthusiasts exclusive access to new releases, author events, and special discounts."
  },
  {
    id: 150,
    goalOfTheDraft: "Customer Testimonials",
    subjectLine: "Hear What Our Readers Are Saying!",
    purposeOfYourEmail: [
      "Share positive reader testimonials",
      "Highlight favorite books or experiences",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Publishing House] prides itself on reader satisfaction. Since [Year], our commitment to quality and engaging content has earned us the trust and loyalty of the [Location] reading community."
  },

  // --- 21. Manufacturing Industry continues ---
  // [Already covered up to id:100]
  
  // --- 22. Additional Industries ---

  // --- 22. IT Services continues ---
  {
    id: 151,
    goalOfTheDraft: "Promote Exclusive Designer Collection",
    subjectLine: "Exclusive Access to Our Designer Collection – Shop Now!",
    purposeOfYourEmail: [
      "Introduce exclusive designer collection",
      "Highlight unique pieces and designers",
      "Offer limited-time discounts",
      "Encourage immediate purchases"
    ],
    tellUsAboutYou: "At [Your Fashion Brand], we collaborate with top designers to bring you exclusive collections. Since [Year], we've been dedicated to offering [Location] the finest in fashion with unique and timeless pieces."
  },
  {
    id: 152,
    goalOfTheDraft: "Announce Pop-Up Shop",
    subjectLine: "Join Us at Our Pop-Up Shop in [Location]!",
    purposeOfYourEmail: [
      "Announce pop-up shop event",
      "Provide event details (date, time, location)",
      "Highlight exclusive items available",
      "Encourage attendance and purchases"
    ],
    tellUsAboutYou: "[Your Fashion Brand] loves connecting with the [Location] community. Since [Year], our pop-up shops have provided opportunities to explore our latest collections in a unique and engaging setting."
  },
  {
    id: 153,
    goalOfTheDraft: "Promote Sustainable Fashion Line",
    subjectLine: "Go Green with Our New Sustainable Fashion Line!",
    purposeOfYourEmail: [
      "Introduce sustainable fashion line",
      "Highlight eco-friendly materials and practices",
      "Explain environmental benefits",
      "Encourage purchasing with incentives"
    ],
    tellUsAboutYou: "[Your Fashion Brand] is committed to sustainability. Since [Year], we've been incorporating eco-friendly practices in our [Location] operations to ensure a better future for our planet."
  },
  {
    id: 154,
    goalOfTheDraft: "Share Fashion Tips",
    subjectLine: "Top 5 Fashion Tips to Elevate Your Style!",
    purposeOfYourEmail: [
      "Provide valuable fashion tips",
      "Position your brand as a helpful resource",
      "Encourage engagement with content",
      "Link to relevant products or blog"
    ],
    tellUsAboutYou: "At [Your Fashion Brand], we believe in empowering our customers with style. Since [Year], we've been offering [Location] fashion enthusiasts the latest trends and expert advice to help them look their best."
  },
  {
    id: 155,
    goalOfTheDraft: "Customer Testimonials",
    subjectLine: "Hear What Our Happy Customers Are Saying!",
    purposeOfYourEmail: [
      "Share positive customer testimonials",
      "Highlight favorite products or experiences",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Fashion Brand] values every customer relationship. Since [Year], our dedication to quality and personalized service has earned us the trust and loyalty of the [Location] community."
  },

  // --- 23. Transportation & Logistics Industry continues ---
  // [Already covered up to id:125]
  
  // --- 24. Agriculture Industry continues ---
  // [Already covered up to id:130]

  // --- 25. Media & Publishing continues ---
  // [Already covered up to id:150]

  // --- 26. Fashion Industry continues ---
  {
    id: 156,
    goalOfTheDraft: "Promote Exclusive Designer Collection",
    subjectLine: "Exclusive Access to Our Designer Collection – Shop Now!",
    purposeOfYourEmail: [
      "Introduce exclusive designer collection",
      "Highlight unique pieces and designers",
      "Offer limited-time discounts",
      "Encourage immediate purchases"
    ],
    tellUsAboutYou: "At [Your Fashion Brand], we collaborate with top designers to bring you exclusive collections. Since [Year], we've been dedicated to offering [Location] the finest in fashion with unique and timeless pieces."
  },
  {
    id: 157,
    goalOfTheDraft: "Announce Pop-Up Shop",
    subjectLine: "Join Us at Our Pop-Up Shop in [Location]!",
    purposeOfYourEmail: [
      "Announce pop-up shop event",
      "Provide event details (date, time, location)",
      "Highlight exclusive items available",
      "Encourage attendance and purchases"
    ],
    tellUsAboutYou: "[Your Fashion Brand] loves connecting with the [Location] community. Since [Year], our pop-up shops have provided opportunities to explore our latest collections in a unique and engaging setting."
  },
  {
    id: 158,
    goalOfTheDraft: "Promote Sustainable Fashion Line",
    subjectLine: "Go Green with Our New Sustainable Fashion Line!",
    purposeOfYourEmail: [
      "Introduce sustainable fashion line",
      "Highlight eco-friendly materials and practices",
      "Explain environmental benefits",
      "Encourage purchasing with incentives"
    ],
    tellUsAboutYou: "[Your Fashion Brand] is committed to sustainability. Since [Year], we've been incorporating eco-friendly practices in our [Location] operations to ensure a better future for our planet."
  },
  {
    id: 159,
    goalOfTheDraft: "Share Fashion Tips",
    subjectLine: "Top 5 Fashion Tips to Elevate Your Style!",
    purposeOfYourEmail: [
      "Provide valuable fashion tips",
      "Position your brand as a helpful resource",
      "Encourage engagement with content",
      "Link to relevant products or blog"
    ],
    tellUsAboutYou: "At [Your Fashion Brand], we believe in empowering our customers with style. Since [Year], we've been offering [Location] fashion enthusiasts the latest trends and expert advice to help them look their best."
  },
  {
    id: 160,
    goalOfTheDraft: "Customer Testimonials",
    subjectLine: "Hear What Our Happy Customers Are Saying!",
    purposeOfYourEmail: [
      "Share positive customer testimonials",
      "Highlight favorite products or experiences",
      "Build trust and credibility",
      "Encourage others to share their experiences"
    ],
    tellUsAboutYou: "[Your Fashion Brand] values every customer relationship. Since [Year], our dedication to quality and personalized service has earned us the trust and loyalty of the [Location] community."
  },
  {
    id: 161,
    goalOfTheDraft: "Follow Up After Initial Contact",
    subjectLine: "Just Checking In – How Can We Assist You Further?",
    purposeOfYourEmail: [
      "Reference previous interaction or inquiry",
      "Reiterate your value proposition or offer",
      "Address any questions or concerns",
      "Encourage next steps or further engagement"
    ],
    tellUsAboutYou: "At [Your Company Name], we’re committed to providing exceptional [products/services] to our [Location] community. Since [Year], we’ve been dedicated to ensuring our customers receive the best support and solutions tailored to their needs."
  },
  {
    id: 162,
    goalOfTheDraft: "Follow Up After Purchase",
    subjectLine: "Thank You for Your Purchase – Let Us Know How We Can Help!",
    purposeOfYourEmail: [
      "Reference the recent purchase",
      "Reiterate the benefits of the product",
      "Address any potential questions or issues",
      "Encourage reviews or repeat purchases"
    ],
    tellUsAboutYou: "At [Your Store Name], we’re dedicated to providing top-quality products to our [Location] customers. Since [Year], we’ve been committed to ensuring your shopping experience is exceptional."
  },
  {
    id: 163,
    goalOfTheDraft: "Follow Up After Consultation",
    subjectLine: "Thank You for the Meeting – Next Steps?",
    purposeOfYourEmail: [
      "Reference the recent consultation or meeting",
      "Reiterate your service offerings and how they can benefit the client",
      "Address any questions or additional needs",
      "Encourage scheduling a follow-up meeting or signing a contract"
    ],
    tellUsAboutYou: "At [Your Company Name], we specialize in delivering top-notch [services] to businesses in [Location]. Since [Year], we’ve been helping our clients achieve their goals with tailored solutions."
  }
  
  
  
  


  // --- 27. Additional Industries (e.g., Entertainment & Media, Sports & Recreation, Art & Culture, etc.) ---

  // --- 28. Healthcare continues ---
  // [Already covered up to id:165]

  // --- 29. Manufacturing continues ---
  // [Already covered up to id:170]

  // Continue adding entries as needed up to id:170 following the same structure

  // Example:
  // {
  //   id: 171,
  //   goalOfTheDraft: "Goal Description",
  //   subjectLine: "Subject Line",
  //   purposeOfYourEmail: [
  //     "Purpose Point 1",
  //     "Purpose Point 2",
  //     "Purpose Point 3",
  //     "Purpose Point 4"
  //   ],
  //   tellUsAboutYou: "Tell us about your story."
  // },
];

export default draftScripts;
